<template>
    <div>
        <div id="section-to-print">
            <span class="fTop">វិក្កយបត្រសម្រាប់ចេញឲ្យអតិថិជន/កសិករ</span>
            <v-row type="flex" class="row-bg fTitle" justify="center">
                វិក្កយបត្រ
            </v-row>
            <br>
            <hr style="border-top: 3px double">
            <table>
                <tr>
                    <td colspan="8">
                        លេខវិក្កយបត្រ ៖ {{dataDoc.reference || ""}}
                    </td>
                </tr>
                <tr>
                    <td colspan="4">កាលបរិច្ឆេទ ៖ {{dataDoc.date || ""}}</td>
                    <td colspan="4"></td>
                </tr>
                <tr>
                    <td colspan="8" class="fTitle3"><u><b>វិក្កយបត្រចេញពី</b></u></td>
                </tr>
                <tr>
                    <td colspan="5">ឈ្មោះអ្នកលក់ ៖ {{dataDoc.supplier_name ||""}}</td>
                    <td>
                        <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                                    :value="dataDoc.client_type==='beedepo'" label="ប៊ីដេប៉ូ" readonly
                        ></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                                    :value="dataDoc.client_type==='beeshop'" label="ប៊ីសប" readonly
                        ></v-checkbox>
                    </td>
                    <td>
                        <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                                    :value="dataDoc.client_type==='beexpress'" label="ប៊ីអ៊ិចប្រេស" readonly
                        ></v-checkbox>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">អាស័យដ្ឋាន ៖ ភូមិ {{dataDoc.supplier_village_name || ""}}</td>
                    <td colspan="3">ឃុំ {{dataDoc.supplier_communce_name || ""}}</td>
                    <td colspan="2">ស្រុក {{dataDoc.supplier_district_name || ""}}</td>
                </tr>
                <tr>
                    <td colspan="2">ខេត្ត {{dataDoc.supplier_province_name || ""}}</td>
                    <td>លេខទូរស័ព្ទ {{(dataDoc.supplier_mobile || "") | formatPhoneNumber}}</td>
                </tr>
                <tr>
                    <td colspan="8" class="fTitle3"><u><b>ទៅអតិថិជន</b></u></td>
                </tr>
                <tr>
                    <td colspan="5">ឈ្មោះអតិថិជន ៖ {{dataDoc.client_name || ""}}</td>
                    <td colspan="3">លេខទូរស័ព្ទ ៖ {{ (dataDoc.client_phone || "") | formatPhoneNumber }}</td>
                </tr>
                <tr>
                    <td colspan="2">អាសយដ្ឋាន៖ ភូមិ {{dataDoc.client_village_name || ""}}</td>
                    <td colspan="2">ឃុំ {{dataDoc.client_communce_name || ""}}</td>
                    <td colspan="2">ស្រុក {{dataDoc.client_district_name || ""}}</td>
                    <td colspan="2">ខេត្ត {{dataDoc.client_province_name || ""}}</td>
                </tr>
                <tr>
                    <td>យល់ព្រមទូទាត់ប្រាក់</td>
                    <td>ប្រាក់សុទ្ធ</td>
                    <td>កម្ចីធនាគារ</td>
                    <td>ជំពាក់,</td>
                    <td colspan="2">អត្រាការប្រាក់</td>
                    <td colspan="2">រយៈពេល ខែ</td>
                </tr>
                <tr>
                    <td colspan="8">កាលបរិច្ឆេទសងត្រឡប់៖</td>
                </tr>
            </table>

            <table class="border">
                <thead>
                <tr>
                    <th>ល.រ</th>
                    <th>ឈ្មោះទំនិញ</th>
                    <th>ឯកតា</th>
                    <th>ចំនួន</th>
                    <th>តម្លៃ</th>
                    <th>តម្លៃសរុប</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d,i) in dataDoc.transaction_line" :key="i">
                    <td style="text-align: center">{{i+1}}</td>
                    <td>{{d.sku || ""}} : {{d.name || d.product_name}}</td>
                    <td style="text-align: center">{{d.unit_name}}</td>
                    <td>{{d.qty | formatNumber}}</td>
                    <td>{{d.price | formatNumber}}{{ d.currency_symbol }}</td>
                    <td>{{d.qty * d.price | formatNumber}}{{ d.currency_symbol }}</td>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center">សរុប</th>
                    <td colspan="2" style="text-align: center">{{dataDoc.total_amount | formatNumber}}{{
                        getCurrencySymbol(dataDoc.currency_code) }}
                    </td>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center">បានបង់</th>
                    <td colspan="2" style="text-align: center">{{dataDoc.paid_amount | formatNumber}}{{
                        getCurrencySymbol(dataDoc.currency_code) }}
                    </td>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center">នៅសល់</th>
                    <td colspan="2" style="text-align: center">{{(parseFloat(dataDoc.total_amount)-parseFloat(dataDoc.paid_amount || 0)) | formatNumber}}{{
                        getCurrencySymbol(dataDoc.currency_code) }}
                    </td>
                </tr>
                </tbody>
            </table>


            <table>
                <tr>
                    <td>ស្នាមមេដៃអតិថិជន</td>
                    <td style="text-align: center">ហត្ថលេខា/ស្នាមមេដៃអ្នកលក់</td>
                </tr>
                <br><br>
                <tr>
                    <td><span style="border-top: 1px solid">កាលបរិច្ឆេទ ៖ ......./................/..........</span>
                    </td>
                    <td style="text-align: right"><span style="border-top: 1px solid">កាលបរិច្ឆេទ ៖ ......./................/...........</span>
                    </td>
                </tr>

            </table>
            <div class="footer-right">
                <p>Invoice to Farmer-V0 {{ today }}</p>
            </div>
        </div>


    </div>

</template>

<script>

    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";
    import MainMixin from "../../../mixins/mainMixin"

    export default {
        name: "ToFarmer",
        mixins: [MainMixin],

        data() {
            return {
                valid: false,
                loadingReport: false,
                params: {
                    dateRange: [],
                },
                today: moment().format("YYYYMMDD"),
                dataDoc: {}
            }
        },
        methods: {
            handlePrint(event) {
                event.preventDefault();
                window.print();
            },
            handleRun(id, back) {
                let vm = this;
                vm.loadingReport = true;

                let url = provider.baseURL + provider.getListTransactionProductTakeOut;
                return new Promise((resolve, reject) => {
                    axios.post(url, {
                        search: "",
                        id: id,
                        offset: 0,
                        reference: "",
                        sort_by: "created_at",
                        sort_desc: 0,
                        limit: 1,
                    }, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                resolve(res.data.data);
                                let newItem = res.data.data[0];
                                if (newItem) {
                                    vm.dataDoc = Object.assign({}, newItem);
                                    vm.dataDoc.total_amount = parseFloat(vm.dataDoc.total_amount);
                                    vm.totalQty = 0;
                                    vm.dataDoc.transaction_line = vm.dataDoc.transaction_line.map((d) => {
                                        if (parseFloat(d.qty) > 0) {
                                            d.currency_code = vm.dataDoc.currency_code;
                                            d.qty = parseFloat(d.qty);
                                            d.price = parseFloat(d.price);
                                            d.sub_total = parseFloat(d.qty * d.price);
                                            vm.totalQty += d.qty;
                                            return d;
                                        }
                                    })
                                    vm.$nextTick(() => {
                                        window.print();
                                        vm.$router.push({name: back});
                                    })
                                }
                            }
                        },
                        error => {
                            reject(error);
                        }
                    );
                })
            }
        },
        created() {
            let vm = this;
            let id = vm.$route.params.id;
            let back = vm.$route.params.back;
            if (id) {
                setTimeout(function () {
                    vm.handleRun(id, back);
                }, 300)
            }
        },
        watch: {},
    }
</script>